<template>
  <div class="modal">
    <AlertModalV2 v-if="isFileErrorModal" @confirm-btn="isFileErrorModal = false">
      <template #alertmodal-nontitle v-html="fileErrorText"> </template>
    </AlertModalV2>
    <!-- 파일 등록 완료 -->
    <AlertModalV2 v-if="isSuccessModal" @confirm-btn="onClickBtnSuccessModal">
      <template #alertmodal-nontitle isSuccessModal> 파일이 등록되었습니다. </template>
    </AlertModalV2>
    <div class="broadcastfile-modal">
      <!-- broadcastfile-header -->
      <div class="broadcastfile-header">
        <div class="header-wrap">
          <img class="arrow-left-icon cursor" src="/media/images/icon/arrow-left-icon.png" alt="arrow-left-icon.png" />
          <h1 class="header-title">파일 업로드</h1>
        </div>
        <a class="common-close-iconwrap  cursor" tabindex="0" @click="onClickClose">
          <img class="common-close-iconwrap" src="/media/images/icon/close-black-icon.png" alt="close-black-icon.png" />
        </a>
      </div>

      <!-- broadcastfile-contents -->
      <div class="broadcastfile-contents">
        <!-- Step 1 : 파일 업로드-->
        <h1 class="step-title" v-if="step === 1">파일을 업로드해주세요.</h1>

        <div
          class="file-uploadbox"
          v-if="step === 1"
          @click="onClickOpenFile"
          draggable="true"
          @dragstart="onDragStart"
          @dragover.prevent="onDragOver"
          @drop="onDrop"
        >
          <img class="mp3-icon" src="/media/images/icon/mp3-icon.png" alt="mp3-icon.png" />
          <p class="fileupload-text">
            클릭하거나 드래그로 mp3 파일을 업로드해주세요. <br />
            파일 용량은 10MB 이하로 제한됩니다.
          </p>
          <input type="file" hidden ref="file" accept=".mp3" @change="onUploadMp3()" />
        </div>

        <!-- Step 2 : 파일 업로드 완료-->
        <h1 class="step-title" v-else-if="step === 2">파일 업로드 완료</h1>
        <div class="inputbox" v-if="step === 2">
          <InputBox :disabled="true" :status="'disabled'" :value="fileInfo.name">
            <template #beforecontents>
              <img class="music-file" src="/media/images/icon/music-file-icon.png" alt="music-file-icon.png" />
            </template>

            <template #aftercontents>
              <img
                class="delete-file"
                @click="onClickDelete"
                src="/media/images/icon/file-delete-icon.png"
                alt="file-delete-icon.png"
              />
            </template>
          </InputBox>
        </div>
        <!-- Step 3 : 파일명 입력-->
        <h1 class="step-title" v-if="step === 3">파일명을 설정해주세요.</h1>
        <div class="inputbox" v-if="step === 3">
          <InputBox
            :placeholder="'ex) 오프닝 멘트'"
            :value="filename"
            ref="inputboxWrap"
            @change-input="onChangeInput"
          ></InputBox>
        </div>

        <div class="error-wrap" v-if="step === 3 && filename.length > 10">
          <ErrorMessage :errortext="'파일명은 띄어쓰기 포함 10글자까지만 가능합니다.'" />
        </div>
      </div>

      <div class="broadcastfile-footer">
        <div class="next-btn">
          <BasicButton :boxsize="'sm'" :disabled="btnDisabled" @click-btn="onClickNext">
            <template #btnname>다음</template>
          </BasicButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicButton from '../BasicButton/BasicButton.vue';
import InputBox from '../InputBox/InputBox.vue';
import ErrorMessage from '../ErrorMessage/ErrorMessage.vue';
import AlertModalV2 from '../modal/AlertModalV2.vue';
import { registMySoundByFile, uploadChosenFile } from '@/service/api/mysound';
export default {
  components: {
    BasicButton,
    InputBox,
    ErrorMessage,
    AlertModalV2
  },
  emits: ['close-fileupload', 'success-fileupload'],
  data() {
    return {
      step: 1,
      filename: '',
      fileInfo: null,
      fileUploadInfo: null,
      isSuccessModal: false,
      isFileErrorModal: false,
      fileErrorText: '',
      isBtnDisabled: false,
      isTextError: false,
      userId: this.$cookies.get('userId'),
      spaceId: this.$cookies.get('spaceId'),
      isOver: false
    };
  },
  methods: {
    onDrop(event) {
      event.preventDefault(); // ← 새창 방지
      this.isOver = false;

      const droppedFile = event.dataTransfer.files[0];
      this.onUploadMp3(droppedFile);
    },
    onDragStart(event) {
      event.dataTransfer.setData('text/plain', 'drag-item-123');
    },
    onDragOver() {
      this.isOver = true;
    },
    onClickBtnSuccessModal() {
      this.$gatag.event('web_broadcast_register_page_done'); // 파일 등록 완료 버튼
      this.isSuccessModal = false;
      this.$emit('success-fileupload');
    },
    onClickDelete() {
      this.fileInfo = null;
      this.step = 1;
    },
    onClickOpenFile() {
      if (this.$refs.file) {
        this.$refs.file.click();
      }
    },
    onClickClose() {
      this.$gatag.event('web_broadcast_file_upload_page_back'); // 파일 업로드 뒤로가기 버튼
      this.$emit('close-fileupload');
    },
    onChangeInput(val) {
      this.filename = val;
      if (this.filename.length > 10) {
        setTimeout(() => {
          this.filename = val.slice(0, 10);
          this.$refs.inputboxWrap.textSlice();
        }, 800);
      }
    },
    onUploadMp3(file) {
      const fileInfo = file || this.$refs.file.files[0];

      const returnVal = this.mp3Filter(fileInfo);
      if (returnVal) {
        this.fileInfo = fileInfo;
        this.step = 2;
      }
    },
    async uploadChosenFile() {
      this.isBtnDisabled = true;
      const form = new FormData();
      form.append('userId', this.userId);
      form.append('spaceId', this.spaceId);
      form.append('fileToUpload', this.fileInfo);
      try {
        this.isBtnDisabled = true;
        const returnVal = await uploadChosenFile(form);
        if (returnVal.data.resultCd === '0000') {
          const result = returnVal.data.result;
          this.fileUploadInfo = result;
          this.step = 3;
        } else {
          throw Error(returnVal.data.resultCd);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isBtnDisabled = false;
      }
    },
    mp3Filter(info = { name: '', size: 0 }) {
      const { name, size } = info;
      const mb = 1024 * 1024; // 1mb(메가)
      const limitSize = mb * 10;
      if (name.split('.')[1].toLowerCase() !== 'mp3') {
        this.fileErrorText = `업로드한 파일은 지원하지 않는 형식입니다. <br/> 다시 확인 후 업로드 해주세요.`;
        this.isFileErrorModal = true;

        return false;
      } else if (limitSize < size) {
        this.fileErrorText = `업로드한 파일 용량이 초과되었습니다. <br/> 다시 확인 후 업로드 해주세요.`;
        this.isFileErrorModal = true;

        return false;
      } else {
        return true;
      }
    },
    onClickNext() {
      this.$gatag.event('web_broadcast_file_upload_page_next'); // 파일 업로드 다음 버튼
      if (this.step === 2) {
        this.uploadChosenFile();
      } else if (this.step === 3) {
        this.registMySoundByFile();
      }
    },
    async registMySoundByFile() {
      try {
        const param = {
          userId: this.userId,
          spaceId: this.spaceId,
          soundTitle: this.filename,
          tempNo: this.fileUploadInfo.tempNo,
          playtime: this.fileUploadInfo.playtime
        };
        this.isBtnDisabled = true;
        const returnVal = await registMySoundByFile(param);
        if (returnVal.data.resultCd === '0000') {
          this.isSuccessModal = true;
        } else {
          throw Error(returnVal.data.resultCd);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isBtnDisabled = false;
      }
    }
  },
  computed: {
    btnDisabled() {
      if (this.step === 2) {
        if (this.fileInfo) {
          return this.isBtnDisabled;
        }
      } else if (this.step === 3) {
        if (this.filename) {
          return this.isBtnDisabled;
        }
      }
      return true;
    }
  }
};
</script>
<style scoped src="@/assets/css/broadcastfile/broadcastfile.css"></style>
